import get from 'lodash/get';
import { stopSubmit } from 'redux-form';
import { all, put, takeEvery, call } from 'redux-saga/effects';
import { validateMfaInputFail, validateMfaInputSuccess } from '../actions';
import { MFA_INPUT_FORM } from '../constants';
import {
  showSendSmsVerificationErrorMessage,
  showSendSmsVerificationSuccessMessage,
} from 'utils/saga/mfa';
import { sendSmsVerificationFail, sendSmsVerificationSuccess } from '../../../actions';
import { handleSignInStatus } from 'utils/saga/auth';

function* showError(action) {
  const { message: errorMessage } = get(action, 'error.data', {});

  yield put(
    stopSubmit(MFA_INPUT_FORM, {
      _error: errorMessage,
    }),
  );
}

function* handleSendSmsVerificationSuccess() {
  yield call(showSendSmsVerificationSuccessMessage);
}

function* handleSendSmsVerificationFail(action) {
  yield call(showSendSmsVerificationErrorMessage, action);
}

export function* handleValidateMfaInputSuccess(action) {
  yield call(handleSignInStatus, { action });
}

export default function* watchRequest() {
  yield all([
    takeEvery(validateMfaInputSuccess, handleValidateMfaInputSuccess),
    takeEvery(validateMfaInputFail, showError),
    takeEvery(sendSmsVerificationSuccess, handleSendSmsVerificationSuccess),
    takeEvery(sendSmsVerificationFail, handleSendSmsVerificationFail),
  ]);
}
